import { z } from 'zod';

const materialGroupItem = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  name: z.string(),
  groupId: z.string(),
  parentGroupItemId: z.string().optional(),
  rootCode: z.string(),
  level: z.number(),
  sequence: z.number(),
  mwAccountGroupId: z.string().optional(),
  materialIds: z.array(z.string()),
  ancestryName: z.string(),
});

const traderSiteGroupItem = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  name: z.string(),
  groupId: z.string(),
  parentGroupItemId: z.string().optional(),
  rootCode: z.string(),
  level: z.number(),
  sequence: z.number(),
  mwAccountGroupId: z.string().optional(),
});

export const getGroupItemMaterialsGroupItemsSchema = z.array(materialGroupItem);

export type GetGroupItemMaterialsGroupItemsResponse = z.infer<
  typeof getGroupItemMaterialsGroupItemsSchema
>;

export type GetGroupItemTraderSitesGroupItemsResponse = z.infer<
  typeof getGroupItemTraderSitesGroupItemsSchema
>;

export const getGroupItemTraderSitesGroupItemsSchema = z.array(traderSiteGroupItem);
